import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';
import HeroSection from './components/HeroSection';
import ProductsSection from './components/ProductsSection';
import SkincareSection from './components/SkincareSection';
import CertificationSection from './components/CertificationSection';
import TestimonialsSection from './components/TestimonialsSection';
import ContactSection from './components/ContactSection';
import WholesaleSection from './components/WholesaleSection';
import SeoJsonLd from '../../components/feature/SeoJsonLd';

const Home = () => {
  return (
    <div className="min-h-screen bg-white">
      <SeoJsonLd />
      <Navbar />
      <main>
        <HeroSection />
        <ProductsSection />
        <SkincareSection />
        <CertificationSection />
        <TestimonialsSection />
        <WholesaleSection />
        <ContactSection />
      </main>
      <Footer />

      {/* Botón flotante de WhatsApp */}
      <a
        href="https://wa.me/50661025212"
        target="_blank"
        rel="noopener noreferrer nofollow"
        className="fixed bottom-6 left-6 z-50 flex items-center gap-2 bg-[#25D366] text-white px-4 py-3 rounded-full shadow-lg hover:bg-[#1ebe5d] transition-all duration-300 hover:scale-105 cursor-pointer whitespace-nowrap"
        aria-label="Contactar por WhatsApp"
      >
        <div className="w-6 h-6 flex items-center justify-center">
          <i className="ri-whatsapp-line text-xl"></i>
        </div>
        <span className="text-sm font-medium">¿Tienes dudas?</span>
      </a>
    </div>
  );
};

export default Home;
